//React
import React, { Component } from 'react';
import { connect } from 'react-redux';
//SVG
import {commentSvg} from '@assets';
//Styles
import './styles.scss';
//Components
import CommentsNotifySidebar from "@components/Sidebars/CommentsNotifySidebar";

class CommentsNotify extends Component {

    constructor(props) {
        super(props);
        this.state = {
            hoverText: false,
            open: false
        }
    }

    handleMenuToggle = () => {
        this.setState({ open: !this.state.open })
    };

    render() {
        const { open } = this.state;
        const { sockets } = this.props.data;
        const { cleanSocketsTicketById, viewSocketsTicket, cleanAllSocketTickets } = this.props;

        var commentsLength = Object.keys(sockets?.eventTickets)?.length;
        return (
            <React.Fragment>
                <div id={"submenu_btn_notifications"} className={`comments_notify ${open ? 'open' : ''}`} onClick={this.handleMenuToggle}>
                    {
                        commentsLength > 0 &&
                            <div className={"comments_notify_badge"}>
                                {commentsLength}
                            </div>
                    }
                    {commentSvg()}
                </div>
                <CommentsNotifySidebar cleanAllSocketTickets={cleanAllSocketTickets} cleanSocketsTicketById={cleanSocketsTicketById} viewSocketsTicket={viewSocketsTicket} open={open} handleMenuToggle={this.handleMenuToggle} />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    }
}

const c = connect(
    mapStateToProps
)(CommentsNotify);

export default c;